import { Button, Clickable, Col, Input, Logo, Row, SegmentControl, Text } from 'components';
import { Api, checkSpecialChars, logout, theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${(props) => (props.isMobile ? '100vh' : 'calc(100vw - 57%)')};
  background-color: ${theme.GREY_10};
  overflow: hidden;
  ${(props) => props.isMobile && 'display: none;'};
`;

const Image = styled.img`
  height: calc(100vh + 100px);
  position: fixed;
  right: 57%;
`;

const Onboarding = (props) => {
  const [selected, setSelected] = useState(0),
    [username, setUsername] = useState(''),
    [errs, setErrs] = useState([]),
    { t } = useTranslation(),
    { isMobile, signupCode } = useSelector((state) => state.appState),
    [referralCode, setReferralCode] = useState(signupCode || ''),
    dispatch = useDispatch(),
    navigate = useNavigate();

  async function submit() {
    const res = await Api.post(
      '/users/updateUsername',
      {
        username,
        referralCode: selected === 1 ? referralCode : '',
        onboardingStep: 2,
        type: selected === 1 ? 'athlete' : 'fan'
      },
      'username',
      { silent: true }
    );

    if (res?.errs) return setErrs(res.errs);
    if (!res || res.err) return;

    dispatch({
      type: 'UPDATE_USER',
      payload: res
    });

    // if (athleteIdToFollow) {
    //   const responseUserDetails = await Api.get(`/users/getById/${athleteIdToFollow}`);
    //   if (responseUserDetails) {
    //     navigate(`/profile/${responseUserDetails.user.username}`);
    //   } else {
    //     navigate('/home');
    //   }
    // } else {
    // }

    // navigate('/home');
  }

  function handleChange(e, type) {
    const { value } = e.target;

    if (checkSpecialChars(value)) return;

    setErrs(errs.filter((x) => x.input !== type));

    type === 'username' ? setUsername(value) : setReferralCode(value);
  }

  return (
    <React.Fragment>
      <ImageWrapper isMobile={isMobile}>
        <Image src={require('assets/branding/logo-icon-grey-20.png')} />
      </ImageWrapper>

      <Col centerAll>
        <Row
          classsName="row"
          between
          pad="0 16px"
          ht="100vh"
          wid={isMobile ? '100%' : '936px'}
          centerAll={isMobile}
          column={isMobile}
        >
          {!isMobile && (
            <Col center wid="50%" noFlex marg="0 0 0">
              <Col noFlex pos="relative">
                <Col pos="absolute" right="50px">
                  <Col pos="absolute" top="0" left="24px">
                    <Text stencil size="40px">
                      {t('onBoarding.everybody')}
                    </Text>
                  </Col>

                  <Col pos="absolute" top="32px" left="0">
                    <Text stencil size="40px">
                      {t('onBoarding.plays')}
                    </Text>
                  </Col>

                  <Col pos="absolute" top="64px" left="0">
                    <Text stencil size="40px">
                      {t('onBoarding.better')}
                    </Text>
                  </Col>

                  <Col pos="absolute" top="96px" left="40px">
                    <Text stencil size="40px">
                      {t('onBoarding.together')}
                    </Text>
                  </Col>
                </Col>
              </Col>
            </Col>
          )}

          <Col center wid={isMobile ? '0' : '50%'} noFlex>
            <Col center noFlex wid="297px">
              <Col centerAll>
                <Logo wid="296px" />

                <Text h1 marg="32px 0 0">
                  {selected ? t('onBoarding.imAnAthlete') : t('onBoarding.imAFan')}
                </Text>

                <Text center col={theme.GREY_60} wid="296px" marg="8px 0 0">
                  {selected
                    ? t('onBoarding.monetizeYourBrand')
                    : t('onBoarding.connectDirectlyWith')}
                </Text>

                <SegmentControl
                  small
                  wid="100%"
                  marg="32px 0 0"
                  options={[t('common.fan'), t('common.athlete')]}
                  selectedIdx={selected}
                  handleSelect={setSelected}
                  textStyle={{ b2: true, marg: '9px 24px' }}
                />

                <Input
                  marg="28px 0 0"
                  wid="100%"
                  placeholder={t('onBoarding.chooseAUsername')}
                  value={username}
                  onChange={(e) => handleChange(e, 'username')}
                  error={errs.find((x) => x.input === 'username')?.err}
                />

                {!!selected && (
                  <Input
                    marg="16px 0 0"
                    wid="100%"
                    placeholder={t('onBoarding.referralCodeOptional')}
                    value={referralCode}
                    onChange={(e) => handleChange(e, 'referralCode')}
                    error={errs.find((x) => x.input === 'referralCode')?.err}
                  />
                )}

                <Button
                  onClick={submit}
                  marg="28px 0 0"
                  text={t('onBoarding.createAnAccount')}
                  bg={username.length ? '#000' : theme.GREY_20}
                  action="username"
                />

                <Clickable marg="23px 0 0" onClick={() => logout(navigate)}>
                  <Text b1 bold>
                    {t('common.logOut')}
                  </Text>
                </Clickable>
              </Col>
            </Col>
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};

export default Onboarding;
